export default "__VITE_ASSET__bGzq04yE__"